export default "__VITE_ASSET__4jtryLp6__"